import React from 'react';
import ServiceCard from './ServiceCard';
import './Services.css';

const Services = () => {
  const services = [
    {
      title: 'Business Technology Services',
      description: 'Secure foundation for networks, devices, security, and support. Resilient infrastructure with security built in, not bolted on. Fewer headaches, better uptime, one accountable partner.',
      link: '/services/technology',
      icon: '🔧'
    },
    {
      title: 'Business Software Services',
      description: 'Implement and integrate software to simplify workflows. 20 years of CRM/ERP experience. Software should work the way your business does—not the other way around.',
      link: '/services/software',
      icon: '💼'
    },
    {
      title: 'Business Intelligence Services',
      description: 'Turn data into dashboards, automation, and predictive insights. Data only matters when it drives action—faster decisions, reduced repetitive work, and forward-looking intelligence.',
      link: '/services/intelligence',
      icon: '📊'
    }
  ];

  return (
    <section className="services" id="services">
      <div className="services-container">
        <div className="services-grid">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              title={service.title}
              description={service.description}
              link={service.link}
              icon={service.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
